import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './obpp-privacy-statement.html',
  styleUrls: ['./obpp-privacy-statement.scss'],
})
export class PrivacyComponent implements OnInit {
  currentLang$: Observable<string>;
  activeSection: string | null = null;
  purolatorPrivacyEmail = `${environment.purolatorPrivacyEmail}`;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.currentLang$ = this.translate.onLangChange.pipe(
      map(event => event.lang),
      startWith(this.translate.currentLang || 'en')
    );
  }

  ngOnInit(): void {}

  toggleSection(sectionKey: string): void {
    this.activeSection = this.activeSection === sectionKey ? null : sectionKey;
  }
}